import "../../../styles/uniqueNews.css";
import React from "react";
import api from "../../../services/api";
import CarouselIMG from "../img/CarouselIMG";
import Loading from "../others/Loading";
import { imagemURL, link_mapa } from "../../../services/variables";
import styles from "../../../styles/module/news3.module.css";

export default class Seletivo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsLast: [],
      dataFormat: "",
      renderLoading: true,
      multiImg: [],
    };
  }

  componentDidMount() {
    api
      .post(`/news/unique/${this.props.slugNewsSystem}`)
      .then((res) => {
        const result = res.data;
        if (result.err) {
          //this.setState({renderLoading: false});
          //this.setState({renderLoading: false});
        } else {
          console.log(result);
          this.setState({ newsLast: result.res, renderLoading: false });
        }
      })
      .catch((err) => console.log("erro, DB"));
  }

  render() {
    return (
      <>
        {this.state.renderLoading ? (
          <Loading />
        ) : (
          <div className={styles.container}>
            {this.state.newsLast.map((news, i) => (
              <div className={styles.newsItem} key={i}>
                <div className={`${styles.header} ${styles.ajuste}`}>
                  <h1 className={styles.title}>
                    PROCESSO DE SELEÇÃO PARA A OLIMPÍADA DE MATEMÁTICA CODOENSE
                  </h1>
                </div>
                <div className={styles.imageWrapper}>
                  {news.IMG === "logo.jpg" || "logo.png" ? null : (
                    <img
                      width={360}
                      alt="imagem da notícia"
                      src={imagemURL + news.IMG}
                    />
                  )}
                </div>

                <div className="section-unique-news">
                  <div className="cards-unique-news" key={i}>
                    {news.IMG === "logo.jpg" || "logo.png" ? null : (
                      <div>
                        <img
                          alt="imagem da notícia"
                          src={imagemURL + news.IMG}
                          className="card-unique-img"
                        />
                      </div>
                    )}
                    <div className="card-unique-txt">
                      <div className="title-unique-body"></div>
                      <div className="news-unique-body">
                        <p>
                          A Prefeitura Municipal de Codó, por meio da Secretaria
                          Municipal de Educação, Ciência e Tecnologia – SEMECTI,
                          e em parceria com a Universidade Federal do Maranhão -
                          Campus Codó, realizou o lançamento da Olimpíada de
                          Matemática Codoense (OMAC) 2025.
                        </p>

                        <p>
                          O projeto tem o objetivo de transformar a educação na
                          rede pública municipal de ensino, reconhecendo que o
                          aprendizado da Matemática representa um dos maiores
                          desafios para os alunos. Para superar esse desafio e
                          estimular o interesse dos estudantes, a Prefeitura, em
                          parceria com a UFMA, está investindo no estímulo do
                          interesse e o estudo da Matemática de forma envolvente
                          e criativa, buscando novas formas de engajar os alunos
                          e tornar o aprendizado mais dinâmico e eficaz.
                        </p>

                        <p>
                          A Olimpíada de Matemática Codoense (OMAC) visa
                          desenvolver o raciocínio lógico, a criatividade, a
                          capacidade analítica e o pensamento crítico dos
                          estudantes codoenses, promover a valorização do ensino
                          da matemática e a atualização das práticas
                          pedagógicas, bem como fomentar a equidade educacional,
                          garantindo oportunidades para todos os alunos,
                          independentemente de suas condições.
                        </p>

                        <p>
                          <strong>Anexos:</strong> <br />
                          <ul>
                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_e42d338b-8363-40a4-9004-75900c931945.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Regulamento Oficial
                              </a>
                            </li>
                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://semecti.codo.ma.gov.br/seletivos/index.php?class=InscricaoFormClubmat"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Link de inscrição
                              </a>
                            </li>

                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_e62f947c-a3a3-4dac-abdc-dcc962ccde5a.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Prorrogação das inscrições da OMAC 2025
                              </a>
                            </li>

                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_a5143554-0b34-4fa2-a038-295e4345cd59.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Gabarito Final Primeira Fase
                              </a>
                            </li>

                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_8cf2507a-704c-4b31-b788-dadd3146def8.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Relação de Alunos Classificados Para a 2ª Fase da OMAC
                              </a>
                            </li>

                            <li>
                              <span>&#8226;</span> &nbsp;
                              <a
                                href="https://forms.gle/rrhepYxHkTAn6s5R9"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Inscrição de Professores
                              </a>
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                  <CarouselIMG img={news.MULTIPLE_IMG} />
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  }
}
